import gql from 'graphql-tag';
const MULTIPART_ACTIVITY_FRAGMENT = gql `
  fragment MultiPartActivityFragment on MultiPartActivity {
    rounds {
      scrollableHtml {
        id
        elements
      }
      multiSelect {
        answers {
          id
          label
          correct
        }
        hint {
          id
          audioId
          audio {
            id
            src
            description
          }
        }
        incorrectAttempt {
          id
          audioId
          audio {
            id
            src
            description
          }
        }
        instructions {
          id
          audioId
          audio {
            id
            src
            description
          }
        }
        questionHtml {
          id
          elements
        }
      }
      constructAResponse {
        emptyAttempt {
          id
          audioId
          audio {
            id
            src
            description
          }
        }
        incorrectAttempt {
          id
          audioId
          audio {
            id
            src
            description
          }
        }
        instructions {
          id
          audioId
          audio {
            id
            src
            description
          }
        }
        maxCharacterCount
        minCharacterCount
        questionHtml {
          id
          elements
        }
      }
    }
  }
`;
export default MULTIPART_ACTIVITY_FRAGMENT;
